import TextField from '@mui/material/TextField';

const FromTextField = ({
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfkobaicyumonno"
    label="受付番号(購買)"
    size="small"
    inputProps={{ maxLength: 12 }}
    onChange={(event: any) => { onChange(event); }}
  />
);

export default FromTextField;